export enum StepStatuses {
  Pending = 'pending',
  Running = 'running',
  Completed = 'completed',
}
